// extracted by mini-css-extract-plugin
module.exports = {"font-picker":"FontPicker_font-picker__DhOx0","font-list":"FontPicker_font-list__ko5JO","fontLoader":"FontPicker_fontLoader__2vl_n"};